import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import HeaderEN from "../headerEN/headeren";
import FooterEN from "../footerEN/footer";
import './cookiepolicy.scss';

const CookiePolicy = () => {

  useEffect(() => {
    const handleContextmenu = e => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextmenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextmenu);
    };
  }, []);

  return (
    <div className="main-fluid">
      <HeaderEN />
      {/* DESK TOP AND TABS SECTION STARTS HERE */}
      
      <div class="d-md-block">
        <div class="cookie-policy-bannermain-en">
          <div class="cookie-policy-banner-con-en">
            <div class="cookie-policy-banner-sec-en">
              <h1 class="cookie-policy-heading-en">Cookie Policy</h1>
            </div>
          </div>
        </div>
        <div class="cookie-policy-banner-con-en">
          <div class="pri-pol-conent-en pt-4">
            <h1>Cookie Policy</h1>

            <p>This policy specifically explains how “Name of the Business” (hereinafter referred to as "we", "us", "our" in this policy).</p>

            <p>We, our partners, and users of our services deploy cookies, as well as the options you as Data Subject (“means any identified or identifiable individual to whom personal data relates”) have to control them.</p>

            <h2>What are cookies?</h2>

            <p>Cookies are small pieces of data, stored in text files, which are stored on your computer or other device when websites are loaded in a browser to make user’s experience more efficient. They ensure a consistent and efficient experience for visitors, and perform essential functions such as allowing users to register and remain logged in.</p>

            <h2>How we use cookies?</h2>

            <p>This website uses cookies. We use cookies for a number of different purposes such as to personalise content and ads, to provide social media features and to analyse our traffic. Some cookies are necessary for technical reasons; some enable a personalized experience for both visitors and registered users; and some allow the display of advertising from selected third party networks.</p>

            <p>The applicable Data Protection Legislation (referring to the Oman Personal Data Protection Law, Royal Decree No. 6/2022) states that we may store cookies on your device if they are strictly necessary for the operation of this website. For all other types of cookies, we require your consent.</p>

            <h2>Where we place cookies?</h2>

            <p>We set cookies in a number of different locations across our services. These include:</p>

            <ul>
              <li>On our websites</li>
              <li>In the administrative dashboards of our websites</li>
              <li>On sites we host for our users</li>
              <li>On sites that use our plugins</li>
              <li>In the emails we send</li>
            </ul>

            <p>This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.</p>

            <p>Your consent applies to the following domains: https://www. https://name of the website/</p>

            <h2>Categories of Cookies</h2>

            <p>The table below explains the categories of cookies we use on our websites and why we use them.</p>

            <table>
              <tr>
                <th>Category of cookies</th>
                <th>Why we use these cookies</th>
              </tr>
              <tr>
                <td>Required</td>
                <td>These cookies are essential for our websites and services to perform basic functions and are necessary for us to operate certain features. These include those required to allow registered users to authenticate and perform account-related functions, store preferences set by users such as account name, language, and location, and ensure our services are operating properly.</td>
              </tr>
              <tr>
                <td>Analytics and Performance</td>
                <td>These cookies allow us to optimize performance by collecting information on how users interact with our websites, including which pages are visited most, as well as other analytical data. We use these details to improve how our websites function and to understand how users interact with them.</td>
              </tr>
              <tr>
                <td>Advertising</td>
                <td>These cookies are set by us and our advertising partners to provide you with relevant content and to understand that content’s effectiveness. They may be used to collect information about your online activities over time and across different websites to predict your preferences and to display more relevant advertisements to you.</td>
              </tr>
            </table>

            <h2>Information on the Types of Cookies that are used on our website</h2>

            <p>We have provided details of the types of Cookies that are used on our website as well as other relevant and useful information on the Cookies. You can also find more information on the Cookies when you click the pop-up window.</p>

            <h3>Technical Cookies:</h3>
            <p>These Cookies are necessary to enable you to move around our website and use its features. These Cookies also allow our website to remember your previous action within the same browsing session.</p>

            <h3>Analytical Cookies:</h3>
            <p>These Cookies are used by us or third-party service providers to analyse how our website are used and how they are performing.</p>

            <h3>Functionality Cookies:</h3>
            <p>These Cookies allow our website to remember choices you make when you visit our website in order to provide enhanced, more personalized features to you.</p>

            <h3>Advertising and Retargeting Cookies:</h3>
            <p>These Cookies save information from your browsing history in order to record your interests and your browsing path on our Site.</p>

            <h2>Necessary Cookies</h2>

            <table>
              <tr>
                <th>Name</th>
                <th>Provider</th>
                <th>Type</th>
                <th>Expiry</th>
                <th>Purpose</th>
              </tr>
              <tr>
                <td>Termly_API_CACHE</td>
                <td>TERMLY</td>
                <td>Html_local_storage</td>
                <td>1 Year</td>
                <td>Used to store visitor consent</td>
              </tr>
              <tr>
                <td>Csrf_Token</td>
                <td>TERMLY</td>
                <td>HTTP_Cookie</td>
                <td>29 Days</td>
                <td>Protects against hacking and malicious actors</td>
              </tr>
            </table>

            <h2>Analytics</h2>

            <p>We use Google Analytics (GA4), a web analytics service provided by Google LLC, to analyse website usage.</p>

            <p>Google Analytics uses first-party cookies such as _ga and related cookies prefixed with _ga_ to generate statistical information about website usage.</p>

            <p>For further details, visit: https://support.google.com/analytics/answer/11397207</p>

            <h2>Preferences</h2>

            <p>Preference cookies enable a website to remember information that changes the way the website behaves or looks.</p>

            <table class="table_n">
              <tr>
                <th>Name</th>
                <th>Provider</th>
                <th>Type</th>
                <th>Expiry</th>
                <th>Purpose</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>

            <h2>Statistics</h2>

            <p>Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.</p>
            <table class="table_n">
              <tr>
                <th>Name</th>
                <th>Provider</th>
                <th>Type</th>
                <th>Expiry</th>
                <th>Purpose</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>

            <h2>Marketing</h2>

            <p>Marketing cookies are used to track visitors across websites to display relevant advertisements.</p>
            <table class="table_n">
              <tr>
                <th>Name</th>
                <th>Provider</th>
                <th>Type</th>
                <th>Expiry</th>
                <th>Purpose</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>

            <h2>Unclassified</h2>

            <p>Unclassified cookies are cookies that we are in the process of classifying.</p>
            <table class="table_n">
              <tr>
                <th>Name</th>
                <th>Provider</th>
                <th>Type</th>
                <th>Expiry</th>
                <th>Purpose</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>

            <h2>How can you refuse or withdraw your consent to the use of cookies?</h2>

            <p>If you do not want Cookies to be placed on your device, you can set your preferences by clicking "Cookie Preferences" on the website. You can change your preferences at any time or withdraw your consent.</p>

            <p>If you wish to remove previously-stored Cookies, you can manually delete them at any time.</p>

            <h2>Contact Details</h2>

            <p>If you have any questions or comments about our Cookie Policy, please contact us at:</p>

            <p><a href="mailto:Privacy@kr.om">Privacy@kr.om</a></p>

          </div>
        </div>
      </div>
      {/* DESK TOP AND TABS SECTION ENDS HERE */}

      {/* FOOTER SECTION STARTS HERE */}
      <FooterEN />
      {/* FOOTER SECTION ENDS HERE */}
    </div>
  );
}

export default CookiePolicy;